import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './BooksConfirmAlert.module.scss';

interface Props {
  termsUrl: string;
  lawUrl: string;
}

const BooksConfirmAlert = ({ termsUrl, lawUrl }: Props) => {
  const intl = useIntl();

  return (
    <div className={css.BooksConfirmAlert}>
      <div className={classNames(css.alert_message_container, css.mb_20px)}>
        <p className={classNames(css.not_complete_msg, css.margin_bottom_0)}>
          {intl.formatMessage({ id: 'books.forms.notCompleteReservation' })}
        </p>
        <p
          className={classNames(
            css.please_confirm_msg,
            css.margin_bottom_14,
            css.margin_top_10,
          )}
        >
          {intl.formatMessage({ id: 'books.forms.pleaseConfirm' })}
        </p>
      </div>
      <p className={css.BooksConfirmAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.confirmAlertMessage3"
          values={{
            terms: (
              <Link
                href={termsUrl}
                prefetch={false}
                className={css.BooksConfirmAlert__Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({ id: 'books.forms.termOfUse' })}
              </Link>
            ),
          }}
        />
        <br />
        <FormattedMessage
          id="books.forms.confirmAlertMessage4"
          values={{
            law: (
              <Link
                href={lawUrl}
                prefetch={false}
                className={css.BooksConfirmAlert__Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({
                  id: 'books.forms.specifiedCommercialTransactionsLaw',
                })}
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default BooksConfirmAlert;
